<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :collection="formCollection"
      :addBtn="false"
      :ableSearch="ableSearch"
      :resetWillRequest="true"
      @reset="handelSearch"
    ></search-form>
    <a-modal
      width="700px"
      v-model:open="open"
      :title="pageName"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model no-pdModal"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :editData="editData"
        :disabled="true"
        :data="tableData"
        :idField="idField"
      ></action>
      <approval_process_content :data="approvalProcessData">
      </approval_process_content>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 'max-content'}"
      :customRow="handleRow"
      size="small"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'rowIndex'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'type_id'">
          {{ codeToText(record?.type_id, Enum.carModel.value) }}
        </template>
        <template v-if="column.key === 'type'">
          {{ codeToText(record.type, Enum.blackWhiteListType.value) }}
        </template>
        <template v-if="column.key === 'time_range'">
          {{ record?.visit_begin_time }} 至
          {{ record?.visit_end_time }}
        </template>
        <template v-if="column.key === 'visit_area'">
          {{ codeToText(record?.visit_area, Enum.areaType.value) }}
        </template>
        <template v-if="column.key === 'visitor_type'">
          {{ codeToText(record?.visitor_type, Enum.personVisitType.value) }}
        </template>
        <template v-if="column.key === 'interviewee_depart_id'">
          {{ codeToText(record.interviewee_depart_id, Enum.dept.value) }}
        </template>
        <template v-if="column.key === 'state'">
          {{ codeToText(record?.state, Enum.status.value) }}
        </template>
        <template v-if="column.key === 'create_user_id'">
          {{ codeToText(record.create_user_id, Enum.user.value) }}
        </template>
        <template v-if="column.dataInObject">
          {{
            record[column.dataInObject] &&
            record[column.dataInObject][column.dataIndex]
          }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="showEditModal(record)"
              :loading="loadingRecord === record[idField] + 'detail'"
            >
              详情
            </a-button>
            <a-button
              @click="showApprovalProcess(record)"
              :loading="loadingRecord === record[idField] + 'process'"
              v-if="record.state !== 0"
            >
              审批流程
            </a-button>
            <a-button
              @click="showRevokeModal(record)"
              v-if="ableRevoke && (record.state === 1 || record.state === 2)"
              :loading="loadingRecord === record[idField] + 'revoke'"
            >撤销审批</a-button>
          </span>
        </template>
      </template>
    </a-table>
    <approval_process
      v-model:openModal="approvalProcessOpen"
      :data="approvalProcessData"
    ></approval_process>

    <a-modal v-model:open="revokeModalOpen" title="是否撤销审批？">
      <a-form :model="revokeModalData" ref="revokeModalFormRef" :rules="revokeModalRules">
        <a-form-item label="撤销理由" name="reason">
          <a-textarea v-model:value="revokeModalData.reason" placeholder="请输入撤销理由" />
        </a-form-item>
      </a-form>
      <template #footer>
        <a-button @click="revokeModalOpen = false">取消</a-button>
        <a-button type="primary" @click="revoke">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script setup>
  import { ref, onMounted, toRefs, computed } from 'vue'
  import { useStore } from 'vuex'
  import {
    getData,
    getDetail,
    revokeForHis
  } from '@/api/person_application/person_application_history'
  import { approvalProcess } from '@/api/person_application/person_application'
  import action from './action'
  import searchForm from '@/components/search_form'
  import { codeToText } from '@/utils/format'
  import dayjs from 'dayjs'
  import { message } from 'ant-design-vue'
  import approval_process from '@/components/approval_process'
  import approval_process_content from '@/components/approval_process_content'

  //初始化
  const pageName = '园区企业约申请记录'
  const idField = 'person_application_id' //响应数据的id的字段名
  const store = useStore()
  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'personApplyHistory:list')
  )
  const ableRevoke = computed(() =>
    !!permissionList.value?.find(item => item.code === 'personApplyHis:revoke')
  )
  const Enum = toRefs(store.state.common)

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'application_number',
      label: '预约单号',
    },
    {
      type: 'input',
      field: 'visitor_name',
      label: '访客姓名',
      width: '110px',
    },
    {
      type: 'input',
      field: 'visitor_company',
      label: '来访单位',
    },
    {
      type: 'input',
      field: 'visitor_idcard',
      label: '访客证件号码',
    },
    {
      type: 'input',
      field: 'visitor_phone',
      label: '访客联系电话',
    },
    {
      type: 'input',
      field: 'interviewee_name',
      label: '被访人员姓名',
    },
    {
      type: 'input',
      field: 'interviewee_phone',
      label: '被访人联系号码',
    },
    {
      type: 'select',
      field: 'application_type',
      label: '申请类型',
      storeOptions: 'personVisitType',
      width: '110px',
      'allow-clear': true,
    },
    {
      type: 'select',
      field: 'visitArea',
      storeOptions: 'areaType',
      //defaultValue: 1,
      label: '访问区域',
      width: '130px',
      'allow-clear': true,
    },
    /*{
      type: 'select',
      field: 'is_delayed',
      storeOptions: 'delayedType',
      defaultValue: -1,
      label: '延期申请',
      width: '100px',
    },*/
    {
      type: 'select',
      field: 'status',
      storeOptions: 'status',
      defaultValue: -1,
      label: '审核状态',
      width: '130px',
    },
    {
      type: 'dateRange',
      startField: 'visit_begin_time',
      endField: 'visit_end_time',
      // defaultStart: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
      // defaultEnd: dayjs().add(30, 'day').format('YYYY-MM-DD'),
      label: '有效时间范围',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setPerAppliceHistory', params)
  }

  //2、表格
  const columns = [
    {
      title: '序号',
      dataIndex: 'rowIndex',
      key: 'rowIndex',
      align: 'center',
      width: 50,
      fixed: 'left',
    },
    {
      title: '预约单号',
      dataIndex: 'application_number',
      key: 'application_number',
      align: 'left',
    },
    {
      title: '审核状态',
      // dataIndex: 'state',
      // key: 'state',
      dataIndex: 'approval_status',
      key: 'approval_status',
      align: 'left',
      width: 130,
    },
    {
      title: '访客姓名',
      dataIndex: 'visitor_name',
      key: 'visitor_name',
      align: 'left',
    },
    {
      title: '访客证件号码',
      key: 'visitor_idcard',
      dataIndex: 'visitor_idcard',
      align: 'left',
    },
    {
      title: '访客联系电话',
      key: 'visitor_phone',
      dataIndex: 'visitor_phone',
      align: 'left',
    },
    {
      title: '民族',
      dataIndex: 'visitor_nation',
      key: 'visitor_nation',
      align: 'left',
    },
    {
      title: '申请园区',
      dataIndex: 'visit_area',
      key: 'visit_area',
      align: 'left',
    },
    {
      title: '来访单位',
      dataIndex: 'visitor_company',
      key: 'visitor_company',
      align: 'left',
      width: 180,
    },
    {
      title: '来访事由',
      dataIndex: 'visit_content',
      key: 'visit_content',
      align: 'left',
    },
    {
      title: '访客类型',
      dataIndex: 'visitor_type',
      key: 'visitor_type',
      dataInObject: 'personApplication',
      align: 'left',
    },
    {
      title: '被访人员',
      dataIndex: 'interviewee_name',
      key: 'interviewee_name',
      align: 'left',
    },
    {
      title: '被访人联系电话',
      dataIndex: 'interviewee_phone',
      key: 'interviewee_phone',
      align: 'left',
    },
    {
      title: '被访机构',
      dataIndex: 'interviewee_depart_id',
      key: 'interviewee_depart_id',
      align: 'left',
      width: 180,
    },
    {
      title: '来访时间',
      key: 'time_range',
      align: 'left',
    },
    {
      title: '撤销理由',
      dataIndex: 'revoke_reason',
      key: 'revoke_reason',
      align: 'left',
      width: 180,
    },
    {
      title: '创建人',
      dataIndex: 'create_user_id',
      key: 'create_user_id',
      align: 'left',
    },
    /*{
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'left',
    },
    {
      title: '更新时间',
      dataIndex: 'update_time',
      key: 'update_time',
      align: 'left',
    },*/
    {
      title: '提交审核时间',
      dataIndex: 'submit_time',
      key: 'submit_time',
      align: 'left',
      width: 170,
    },
    {
      // title: '最后审核时间',
      title: '审核时间',
      dataIndex: 'approve_time',
      key: 'approve_time',
      align: 'left',
      width: 170,
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      width: '190px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  const handleRow = (record) => {
    return {
      ondblclick: (event) => {
        event.stopPropagation();
        showEditModal(record);
      }
    }
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  
  const cachedSearchParams = computed(() => store.state.search.searchPerAppliceHistory)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })

  //3、详情
  const open = ref(false)
  const editData = ref(null)
  const showEditModal = async (data) => {
    loadingRecord.value = data[idField] + 'detail'
    const detail = await fetchDetail(data[idField])
    loadingRecord.value = null
    if (detail) {
      editData.value = detail
      open.value = true
      approvalProcessData.value = []
      // 获取审批流程
      if (data.state !== 0 && data.state !== 4) {
        await getApprovalProcess(data[idField])
      }
    }
  }
  async function fetchDetail(id) {
    const res = await getDetail({ id })
    if (res.success) {
      return res.data
    } else {
      message.warn('获取详情失败')
    }
  }
  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、审批流程
  const approvalProcessOpen = ref(false)
  const approvalProcessData = ref()
  async function getApprovalProcess(id) {
    const res = await approvalProcess({ id })
    approvalProcessData.value = res.data
  }
  async function showApprovalProcess(record) {
    loadingRecord.value = record[idField] + 'process'
    await getApprovalProcess(record[idField])
    approvalProcessOpen.value = true
    loadingRecord.value = null
  }
  async function revoke() {
    await revokeModalFormRef.value.validate()
    const { id, reason } = revokeModalData.value
    loadingRecord.value = id + 'revoke'
    try {
      const res = await revokeForHis({ id, reason })
      if (res.success) {
        message.success(res.msg)
        revokeModalOpen.value = false
      }
      fetch()
    } finally {
      loadingRecord.value = null
    }
  }

  const revokeModalFormRef = ref()
  const revokeModalRules = {
    reason: [
      { required: true, message: '请输入撤销理由', trigger: 'blur' }
    ]
  }
  const revokeModalOpen = ref(false)
  const revokeModalData = ref({
    reason: '',
    id: ''
  })
  function showRevokeModal(record) {
    revokeModalData.value = {
      reason: '',
      id: record[idField]
    }
    revokeModalOpen.value = true
  }
</script>
